"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.decodeDibToBmp = decodeDibToBmp;
const base64_1 = require("../../Utils/base64");
function decodeDibToBmp(base64Dib) {
    const cleaned = base64Dib.replace(/\s/g, '');
    const dib = (0, base64_1.base64ToUint8Array)(cleaned);
    const dibHeaderSize = dib[0] | (dib[1] << 8) | (dib[2] << 16) | (dib[3] << 24);
    const bmpFileHeaderSize = 14;
    const dataOffset = bmpFileHeaderSize + dibHeaderSize;
    const fileSize = bmpFileHeaderSize + dib.length;
    const bmp = new Uint8Array(fileSize);
    bmp[0] = 0x42;
    bmp[1] = 0x4d;
    bmp[2] = fileSize & 0xff;
    bmp[3] = (fileSize >> 8) & 0xff;
    bmp[4] = (fileSize >> 16) & 0xff;
    bmp[5] = (fileSize >> 24) & 0xff;
    bmp[10] = dataOffset & 0xff;
    bmp[11] = (dataOffset >> 8) & 0xff;
    bmp[12] = (dataOffset >> 16) & 0xff;
    bmp[13] = (dataOffset >> 24) & 0xff;
    bmp.set(dib, bmpFileHeaderSize);
    return { data: bmp, mimeType: 'image/bmp' };
}
//# sourceMappingURL=orcadImageUtils.js.map